<template>
  <div>

    <!--Banner Parallax-->
    <section class="topBanner" ref="parallaxBanner" :style="{ backgroundPositionY: parallaxOffset + 'px', backgroundImage: 'url(/Resources/images/Forage/forageBanner.jpg)' }">
      <div class="bannerOverlay">
        <h1 class="bannerTitle">Forage de puits, pompe et traitement d'eau</h1>
        <p class="bannerSubtitle">Une seule compagnie — Bisson Service</p>
      </div>
    </section>

    <!--Intro-->
    <section class="gridpad">
      <v-row class="d-flex justify-center">
        <v-col cols="12" lg="10">
          <div class="sectionBox">
            <h2 class="sectionTitle txt-c">Un service tout inclus pour votre eau</h2>
            <p class="mt-5 txt-j">Chez Bisson Service, nous offrons un service tout inclus pour répondre à vos besoins en eau. Du forage de votre puits à l'installation complète du système de pompage et de traitement de l'eau, nous prenons tout en charge pour vous offrir une solution clé en main. Faites confiance à notre expertise pour une eau de qualité, directement chez vous.</p>
            <p class="mt-4 interventionLabel"><strong>Nos services incluent :</strong></p>
            <ul class="serviceList mt-3">
              <li class="serviceItem">
                <span class="serviceItemTitle">Forage de puits :</span>
                <span>Forage artésien résidentiel, agricole et commercial avec équipements de pointe.</span>
              </li>
              <li class="serviceItem">
                <span class="serviceItemTitle">Installation de pompe :</span>
                <span>Sélection, installation et mise en service de votre système de pompage adapté à votre puits.</span>
              </li>
              <li class="serviceItem">
                <span class="serviceItemTitle">Installation traitement d'eau :</span>
                <span>Analyse, sélection et installation complète de votre système de filtration et traitement.</span>
              </li>
              <li class="serviceItem">
                <span class="serviceItemTitle">Service clé en main :</span>
                <span>Un seul appel, une seule équipe — du forage jusqu'à l'eau potable à votre robinet.</span>
              </li>
            </ul>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--ContactUs-->
    <contactUs/>

    <!--Cards Pourquoi Bisson-->
    <section class="sectionPad gridpad">
      <v-row class="d-flex justify-center">
        <v-col cols="12" class="txt-c mb-8">
          <h2 class="sectionTitle">Pourquoi choisir Bisson Service ?</h2>
        </v-col>
      </v-row>
      <v-row class="d-flex justify-center">
        <v-col cols="12" sm="6" md="3" class="whyCard" v-for="(card, i) in whyCards" :key="i">
          <div class="whyCardOverlay" @click="navigateContact">
            <span class="whyCardOverlayText">Nous contacter</span>
          </div>
          <div class="whyCardIcon">{{ card.icon }}</div>
          <h3 class="whyCardTitle">{{ card.title }}</h3>
          <p class="whyCardText">{{ card.text }}</p>
        </v-col>
      </v-row>
    </section>

    <!--Photos terrain-->
    <section class="bgPhotos gridpad">
      <v-row class="d-flex justify-center">
        <v-col cols="12" class="txt-c mb-4">
          <h2 class="sectionTitle">Notre équipement de forage</h2>
          <p class="equipmentSubtitle">Des équipements professionnels pour un résultat de qualité</p>
        </v-col>
      </v-row>
      <v-row class="d-flex justify-center">
        <v-col cols="12" lg="4" md="4" sm="12" v-for="(photo, index) in photos" :key="index">
          <div class="photoCard" @click="openLightbox(index)">
            <div class="photoImg" :style="{ backgroundImage: 'url(' + photo.src + ')' }">
              <div class="photoHoverOverlay">
                <span class="zoomIcon"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="22" y2="22"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg></span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Zone Desservie-->
    <section class="sectionPad v-primary-light-1">
      <v-row>
        <v-col cols="12" lg="7" class="txt-j">
          <div class="zonePad">
            <h2 class="sectionTitle mb-4">Zone Desservie</h2>
            <p>Chez Bisson Service, nous offrons nos services de forage de puits dans un rayon de 160 km autour de Drummondville. Voici les régions que nous desservons :</p>
            <ul class="zoneList mt-4">
              <li v-for="(item, i) in zoneItems" :key="i" class="zoneItem">
                <h3 class="zoneliTitle">{{ item.city }}</h3>
                <p class="zoneliText"> : {{ item.text }}</p>
              </li>
            </ul>
          </div>
        </v-col>
        <v-col cols="12" lg="5" class="pa-0 d-flex align-center justify-center mapZoneVCol">
          <div class="mapImg"></div>
        </v-col>
      </v-row>
    </section>

    <!--Publicité Forage-->
    <section>
      <v-row>
        <v-col class="pa-0">
          <div style="width: 100%; height: auto; margin-bottom: -20px;">
            <img style="width: 100%; height: auto;" src="/Resources/images/publicity/PubForage.jpg"/>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Lightbox Popup-->
    <transition name="lightbox-fade">
      <div v-if="lightboxOpen" class="lightboxBackdrop" @click.self="closeLightbox">
        <div class="lightboxContainer">
          <button class="lightboxClose" @click="closeLightbox">&times;</button>
          <button class="lightboxNav lightboxPrev" @click="prevPhoto">&#8592;</button>
          <img class="lightboxImg" :src="photos[lightboxIndex].src" :alt="'Photo forage ' + (lightboxIndex + 1)"/>
          <button class="lightboxNav lightboxNext" @click="nextPhoto">&#8594;</button>
          <div class="lightboxCounter">{{ lightboxIndex + 1 }} / {{ photos.length }}</div>
        </div>
      </div>
    </transition>

  </div>
</template>

<style scoped>
  p { font-size: 18px; color: rgba(var(--menuColor), 0.6); }
  .gridpad { padding: 50px 100px; }
  .sectionPad { padding: 50px 0px; }

  /*#region Banner Parallax*/
  .topBanner {
    height: 600px;
    background-attachment: fixed;
    background-position: center 30%;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    will-change: background-position-y;
  }
  .bannerOverlay {
    background-color: rgba(0, 0, 0, 0.45);
    padding: 40px 70px;
    border-radius: 8px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    max-width: 700px;
  }
  .bannerTitle {
    color: #ffffff;
    font-weight: 700;
    font-size: 32px;
    text-transform: uppercase;
    letter-spacing: 2px;
    margin: 0;
  }
  .bannerSubtitle {
    color: rgba(255,255,255,0.85);
    font-size: 20px;
    font-style: italic;
    margin: 0;
  }
  /*#endregion*/

  /*#region Intro*/
  .sectionBox { padding: 20px 0px 32px 0px; }
  .sectionTitle { color: rgb(var(--secondary)); font-weight: 700; font-size: 26px; }
  .interventionLabel { font-size: 18px; color: rgba(var(--menuColor), 0.8); }
  .serviceList { list-style: none; padding: 0 20px; }
  .serviceItem {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 14px 0px;
    border-bottom: 1px solid rgba(var(--menuColor), 0.1);
    font-size: 18px;
    color: rgba(var(--menuColor), 0.6);
  }
  .serviceItem::before {
    content: '▸';
    color: rgb(var(--primary));
    font-size: 20px;
    flex-shrink: 0;
    margin-top: 1px;
  }
  .serviceItemTitle {
    color: rgb(var(--secondary));
    font-weight: 600;
    margin-right: 6px;
    white-space: nowrap;
  }
  /*#endregion*/

  /*#region Why Cards*/
  .whyCard {
    position: relative;
    max-width: 360px;
    padding: 30px 24px;
    margin: 12px;
    border-radius: 6px;
    border-top: 4px solid rgb(var(--primary));
    background-color: #ffffff;
    box-shadow: 0 0 12px rgba(var(--primary), 0.3);
    transition: transform 0.35s ease, box-shadow 0.35s ease, border-color 0.35s ease;
    animation: slideUpFade 0.6s ease both;
    overflow: hidden;
  }
  .whyCard:nth-child(1) { animation-delay: 0.0s; }
  .whyCard:nth-child(2) { animation-delay: 0.15s; }
  .whyCard:nth-child(3) { animation-delay: 0.30s; }
  .whyCard:nth-child(4) { animation-delay: 0.45s; }
  @keyframes slideUpFade {
    from { opacity: 0; transform: translateY(30px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  .whyCard:hover { transform: translateY(-8px); box-shadow: 0 12px 30px rgba(var(--primary), 0.35); border-top-color: rgb(var(--secondary)); }
  .whyCardOverlay {
    position: absolute; inset: 0;
    background: linear-gradient(135deg, rgba(var(--primary), 0.88), rgba(var(--secondary), 0.88));
    opacity: 0; border-radius: 6px;
    display: flex; align-items: center; justify-content: center;
    transition: opacity 0.3s ease; cursor: pointer;
  }
  .whyCard:hover .whyCardOverlay { opacity: 1; }
  .whyCardOverlayText { color: #fff; font-weight: 700; font-size: 20px; text-transform: uppercase; letter-spacing: 1px; }
  .whyCardIcon { font-size: 36px; margin-bottom: 16px; display: flex; align-items: center; }
  .whyCardTitle { font-size: 20px; color: rgb(var(--primary)); font-weight: 700; margin-bottom: 12px; }
  .whyCardText { font-size: 16px !important; color: rgba(var(--menuColor), 0.65); text-align: justify; line-height: 1.6; }
  /*#endregion*/

  /*#region Photos*/
  .bgPhotos { background-color: rgb(var(--tierce2)); }
  .equipmentSubtitle { font-size: 17px; color: rgba(var(--menuColor), 0.55); margin-top: 6px; }
  .photoCard { border-radius: 8px; overflow: hidden; box-shadow: 0 4px 16px rgba(0,0,0,0.15); cursor: pointer; margin-bottom: 16px; }
  .photoImg { height: 280px; background-position: center; background-repeat: no-repeat; background-size: cover; transition: transform 0.4s ease; position: relative; background-color: #ffffff; }
  .photoCard:hover .photoImg { transform: scale(1.04); }
  .photoHoverOverlay { position: absolute; inset: 0; background-color: rgba(0,0,0,0); display: flex; align-items: center; justify-content: center; transition: background-color 0.3s ease; }
  .photoCard:hover .photoHoverOverlay { background-color: rgba(0,0,0,0.35); }
  .zoomIcon { display: flex; align-items: center; justify-content: center; opacity: 0; transition: opacity 0.3s ease; filter: drop-shadow(0 2px 6px rgba(0,0,0,0.6)); }
  .photoCard:hover .zoomIcon { opacity: 1; }
  /*#endregion*/

  /*#region Zone Desservie*/
  .zonePad { padding: 20px 60px; }
  .zoneList { list-style: none; padding: 0; }
  .zoneItem { padding: 10px 0px; border-bottom: 1px solid rgba(var(--menuColor), 0.1); }
  .zoneliTitle { display: inline; font-size: 18px; color: rgb(var(--primary)); font-weight: 700; }
  .zoneliText { display: inline; font-size: 16px; color: rgba(var(--menuColor), 0.6); }
  .mapImg {
    height: 450px; width: 80%;
    background-image: url("../../public/Resources/images/logo/map.png");
    background-position: center; background-repeat: no-repeat; background-size: contain;
    transform: rotate(20deg); opacity: 0.4;
  }
  /*#endregion*/

  /*#region Lightbox*/
  .lightboxBackdrop { position: fixed; inset: 0; background-color: rgba(0,0,0,0.88); z-index: 99999; display: flex; align-items: center; justify-content: center; }
  .lightboxContainer { position: relative; display: flex; align-items: center; justify-content: center; max-width: 90vw; max-height: 90vh; z-index: 100000; }
  .lightboxImg { max-width: 85vw; max-height: 85vh; border-radius: 6px; box-shadow: 0 8px 40px rgba(0,0,0,0.6); object-fit: contain; display: block; }
  .lightboxClose { position: fixed; top: 20px; right: 28px; font-size: 44px; color: #ffffff; background: none; border: none; cursor: pointer; line-height: 1; opacity: 0.85; transition: opacity 0.2s; z-index: 100001; }
  .lightboxClose:hover { opacity: 1; }
  .lightboxNav { position: absolute; top: 50%; transform: translateY(-50%); background-color: rgba(255,255,255,0.15); border: 2px solid rgba(255,255,255,0.5); color: #fff; font-size: 26px; width: 50px; height: 50px; border-radius: 50%; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: background-color 0.2s; z-index: 100001; }
  .lightboxNav:hover { background-color: rgba(255,255,255,0.3); }
  .lightboxPrev { left: -65px; }
  .lightboxNext { right: -65px; }
  .lightboxCounter { position: absolute; bottom: -36px; left: 50%; transform: translateX(-50%); color: rgba(255,255,255,0.7); font-size: 15px; }
  .lightbox-fade-enter-active, .lightbox-fade-leave-active { transition: opacity 0.25s ease; }
  .lightbox-fade-enter-from, .lightbox-fade-leave-to { opacity: 0; }
  /*#endregion*/

  @media handheld, only screen and (max-width: 600px) {
    .gridpad { padding: 30px 15px; }
    .bannerTitle { font-size: 24px; }
    .bannerOverlay { padding: 25px 20px; }
    .serviceItem { flex-direction: column; gap: 4px; }
    .serviceItemTitle { white-space: normal; }
    .topBanner { height: 400px; background-attachment: scroll; }
    .lightboxPrev { left: -40px; }
    .lightboxNext { right: -40px; }
    .lightboxNav { width: 36px; height: 36px; font-size: 18px; }
    .whyCard { max-width: 100% !important; margin: 8px 0; padding: 20px 16px; }
    .whyCardText { text-align: left; }
    .zonePad { padding: 20px 15px; }
    .mapZoneVCol { display: none !important; }
  }
  @media handheld, only screen and (max-width: 960px) {
    .gridpad { padding: 30px 25px; }
    .photoImg { height: 220px; }
    .topBanner { height: 500px; background-attachment: scroll; }
    .whyCard { max-width: 100% !important; }
    .zonePad { padding: 20px 25px; }
    .mapZoneVCol { display: none !important; }
  }
  @media handheld, only screen and (max-width: 1279px) {
    .gridpad { padding: 40px 40px; }
    .zonePad { padding: 20px 30px; }
    .topBanner { height: 500px; background-attachment: scroll; }
  }
</style>

<script>
  import contactUs from '@/components/bannerContactUs.vue';

  export default {
    name: 'ForagePage',
    data: function() {
      return {
        parallaxOffset: 0,
        lightboxOpen: false,
        lightboxIndex: 0,
        whyCards: [
          {
            icon: '🏆',
            title: 'Expertise depuis 1958',
            text: "Plus de 60 ans de savoir-faire en forage de puits et traitement d'eau dans la région de Drummondville."
          },
          {
            icon: '🔧',
            title: 'Service clé en main',
            text: "Du forage au robinet, une seule équipe prend tout en charge. Pas besoin de coordonner plusieurs entrepreneurs."
          },
          {
            icon: '💧',
            title: 'Eau de qualité garantie',
            text: "Analyse, traitement et certification de votre eau potable. Nous ne partons pas tant que votre eau est parfaite."
          },
          {
            icon: '⚡',
            title: 'Intervention rapide',
            text: "Nos équipes interviennent rapidement sur tout votre territoire. Service d'urgence disponible 24h."
          },
        ],
        zoneItems: [
          { city: 'Drummondville', text: "Au coeur de notre activité — interventions rapides garanties." },
          { city: 'Saint-Hyacinthe', text: "Forage résidentiel, agricole et commercial dans toute la région." },
          { city: 'Trois-Rivières', text: "Services complets de forage et installation pour tous les secteurs." },
          { city: 'Centre-du-Québec', text: "Couverture complète de la région pour vos besoins en eau potable." },
          { city: 'Sorel-Tracy', text: "Interventions rapides et expertise reconnue dans la région." },
          { city: 'Estrie', text: "Présents pour vos besoins résidentiels, agricoles et industriels." },
        ],
        photos: [
          { src: '/Resources/images/Forage/forage-1.jpg' },
          { src: '/Resources/images/Forage/forage-2.jpg' },
          { src: '/Resources/images/Forage/forage-3.jpg' },
        ],
      };
    },
    mounted: function() {
      window.addEventListener('scroll', this.handleParallax);
      window.addEventListener('keydown', this.handleKeydown);
    },
    beforeDestroy: function() {
      window.removeEventListener('scroll', this.handleParallax);
      window.removeEventListener('keydown', this.handleKeydown);
    },
    methods: {
      navigateContact: function() { this.$router.push('/contact'); },
      handleParallax: function() {
        if (!this.$refs.parallaxBanner) return;
        this.parallaxOffset = Math.round(window.scrollY * 0.4);
      },
      openLightbox: function(index) {
        this.lightboxIndex = index;
        this.lightboxOpen = true;
        document.body.style.overflow = 'hidden';
      },
      closeLightbox: function() {
        this.lightboxOpen = false;
        document.body.style.overflow = '';
      },
      nextPhoto: function() {
        this.lightboxIndex = (this.lightboxIndex + 1) % this.photos.length;
      },
      prevPhoto: function() {
        this.lightboxIndex = (this.lightboxIndex - 1 + this.photos.length) % this.photos.length;
      },
      handleKeydown: function(e) {
        if (!this.lightboxOpen) return;
        if (e.key === 'Escape')     this.closeLightbox();
        if (e.key === 'ArrowRight') this.nextPhoto();
        if (e.key === 'ArrowLeft')  this.prevPhoto();
      },
    },
    components: {
      contactUs,
    },
  }
</script>